// Platform detection utilities for React Native vs Web
const isReactNative = ()=>{
    return typeof navigator !== 'undefined' && navigator.product === 'ReactNative';
};
const isWeb = ()=>{
    return typeof window !== 'undefined' && typeof window.document !== 'undefined';
};
// Platform-specific restart functionality
const platformRestart = (reason)=>{
    if (isReactNative()) {
        // Try to use RNRestart if available
        try {
            // @ts-ignore - Optional dependency
            const { RNRestart } = require('src/nativeModule/RNRestartModule');
            if (RNRestart && RNRestart.restart) {
                RNRestart.restart(reason || 'Auth restart');
                return;
            }
        } catch (error) {
            console.warn('RNRestart not available:', error);
        }
    }
};

export { isReactNative, isWeb, platformRestart };
//# sourceMappingURL=platform.js.map
